import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalProfileService } from '../../../services/local-profile.service';
import { finalize, forkJoin, of, switchMap } from 'rxjs';
import { WorkflowService } from '../../../services/workflow.service';
import { Skus } from 'app/models/enums/Skus';
import { WorkblockService } from '../../../services/workblock.service';
import { LocalProfileInitializationComponent as SharedLocalProfileInitializationComponent } from '../../shared/local-profiles/local-profile-initialization/local-profile-initialization.component';


@Component({
  selector: 'app-components-managecustomer-local-profiles',
  templateUrl: './local-profiles.component.html'
})
export class LocalProfilesComponent implements IActivatable, OnInit {
  @ViewChild(SharedLocalProfileInitializationComponent) localProfileInitializationComponent: SharedLocalProfileInitializationComponent;

  customer: Boo.Objects.Customer;
  localProfileRequirements: Boo.LocalProfiles.Models.LocalProfileRequirements;
  isLoading = true;
  shouldLockScreen = false;
  canEditInitialization = false;
  editingInitialization = false;

  constructor(
    private localProfileService: LocalProfileService,
    private workblockService: WorkblockService,
    private workflowService: WorkflowService) { }

  canActivate?(_user: Boo.Objects.User, _partner: Boo.Objects.Partner, params: any): boolean {
    this.customer = ko.mapping.toJS(params.customer);
    return true;
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    forkJoin([
      this.localProfileService.getRequirements(this.customer.CustomerId),
      this.workflowService.hasOpenOnboardingWorkflow(this.customer.CustomerId)
    ])
    .pipe(
      finalize(() => this.isLoading = false),
      switchMap(([localProfileRequirements, hasOpenOnboardingWorkflow]) => {
        this.localProfileRequirements = localProfileRequirements;

        this.shouldLockScreen = hasOpenOnboardingWorkflow || localProfileRequirements.HasOpenInitialization;

        const checkWorkblocks = this.shouldLockScreen && localProfileRequirements.OpenInitializationSkus.includes(Skus.SEOMinute);
        return checkWorkblocks
          ? this.workblockService.hasWorkblockForTaskOfTaskType(this.customer.CustomerId, Boo.Objects.Enums.TaskTypeEnum.BusinessProfileValidationAndAugmentation)
          : of(false);
      }))
    .subscribe({
      next: (hasWorkblock) => {
        this.canEditInitialization = this.shouldLockScreen && this.localProfileRequirements.OpenInitializationSkus.includes(Skus.SEOMinute) && hasWorkblock;
      },
      error: (err) => toastr.error('Failed to load data:', err)
    });
  }

  toggleEditingInitialization(editing: boolean): void {
    this.editingInitialization = editing;
  }

  saveInitilization(): void {
    this.localProfileInitializationComponent.save().subscribe({
      next: () => {
        this.load();
        this.toggleEditingInitialization(false);
        toastr.success('Onboarding Instructions saved successfully.');
      },
      error: (err) => toastr.error('Failed to save data:', err)
    });
  }
}
